const Quotation = () => {
  return <div>Quotation</div>;
};
export default Quotation;
